import React, { Fragment, useEffect } from 'react'

import {
  Box,
  TableContainer,
  TableRow,
  TableBody,
  TableCell,
  Table,
  Typography,
  TableHead
} from '@mui/material'

import { PickingRouteProductDetail } from '../../../interfaces/PickingRoute/PickingRouteDetails/PickingRouteProductDetail'

import GetAppIcon from '@mui/icons-material/GetApp'

interface PickingProductListProps {
  pickingProductList: PickingRouteProductDetail[]
}

export const PickingProductList: React.FC<PickingProductListProps> = ({
  pickingProductList
}) => {
  const [element, setElement] = React.useState(
    document.getElementById('TABLE__PICKING__PRODUCT__SIZE')
  )
  const [scrollSize, setScrollSize] = React.useState(element?.scrollHeight || 0)
  const [clientSize, setClientSize] = React.useState(element?.clientHeight || 0)
  const [isScrollable, setIsScrollable] = React.useState(false)

  useEffect(() => {
    setScrollSize(element?.scrollHeight || 0)
    setClientSize(element?.clientHeight || 0)
  }, [element?.clientHeight, element?.scrollHeight])

  useEffect(() => {
    setIsScrollable(scrollSize > clientSize)
  }, [scrollSize, clientSize])

  useEffect(() => {
    setElement(document.getElementById('TABLE__PICKING__PRODUCT__SIZE'))
  }, [pickingProductList, setElement, element])

  const containsPosition: boolean =
    pickingProductList.filter((item) => item.position !== null).length > 0

  return (
    <Fragment>
      <TableContainer
        component={Box}
        style={{ maxHeight: 285, minHeight: 285 }}
        id='TABLE__PICKING__PRODUCT__SIZE'
      >
        <Table size='small' aria-label='a dense table'>
          {containsPosition && (
            <TableHead>
              <TableRow>
                <TableCell>SKU</TableCell>
                <TableCell align='right'>CANT</TableCell>
                <TableCell align='right'>POS</TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {pickingProductList.map(({ name, qty, position }) => (
              <TableRow key='sku'>
                <TableCell align='left'>{name}</TableCell>
                <TableCell align='right'>{qty}</TableCell>
                {position && <TableCell align='right'>{position}</TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display='flex' justifyContent='center' alignItems='center'>
        <Typography>{isScrollable && <GetAppIcon />}</Typography>
      </Box>
    </Fragment>
  )
}
